import React, { useState } from "react";
import { Form, Input, Checkbox, Button, Upload, message } from "antd";
import { Row, Col } from "react-bootstrap";
import { UploadOutlined } from "@ant-design/icons";
import { signin } from "../../api/Login";
import Loader from "../../customJS/Loader";
import SunLife from "../../images/sunLife.svg";
import Canadalife from "../../images/canadalife.svg";
import Logo from "../../images/logo.png";
import Desjardins from "../../images/desjardins.svg";
import { Icon } from "@iconify/react/dist/iconify.js";
import { handleonlyNumber } from "../../customJS/custom";

const Signin = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [logoFileList, setLogoFileList] = useState([]);
  // const [imageFileList, setImageFileList] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const key = "updatable";

  const handleSubmit = (values) => {
    const formData = new FormData();
    console.log("values ", values);

    formData.append("address", values.hospitalAddress.trim());
    formData.append("mailId", values.mailId.trim());
    formData.append("hospitalName", values.hospitalName.trim());
    formData.append("website", values.website.trim());
    formData.append("phoneNo", values.phoneNo.trim());
    formData.append("zipCode", values.zipCode.trim());

    if (logoFileList[0]?.originFileObj) {
      formData.append("hospitalLogo", logoFileList[0].originFileObj);
    }
    // if (imageFileList[0]?.originFileObj) {
    //   formData.append("hospitalImage", imageFileList[0].originFileObj);
    // }

    console.log(formData);
    sendSignInData(formData);
  };

  const sendSignInData = (obj) => {
    signin(obj)
      .then((response) => {
        if (response.data.status === 1) {
          form.resetFields();
          // setImageFileList([]);
          setLogoFileList([]);
          messageApi.open({
            key,
            type: "success",
            content: "submited sucessfully. Our team will call you and send an email with the link once it's done.",
            duration: 2,
          });
          setLoader(false);
        } else if (response.data.status === 0) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else if (response.data.status === -1) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          console.log(
            "Your account has been deleted. Please contact the administrator for help"
          );
          setLoader(false);
        } else {
          messageApi.open({
            type: "error",
            content: "Please try with valid credentials.",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        messageApi.open({
          type: "error",
          content: "Network error, Please try again later.",
          duration: 1,
          className: "ant-alert",
        });
        setLoader(false);
      });
  };

  const validateFile = (file) => {
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      messageApi.error(
        `${file.name} is not a valid file type. Please upload a PNG, JPG or JPEG.`
      );
      return Upload.LIST_IGNORE;
    }
    return false;
  };

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
    },
  };

  const handleBeforeUpload = (file) => {
    const isAllowedType =
      file.type === "image/png" || file.type === "image/jpeg";
    const isLessThan5MB = file.size / 1024 / 1024 < 5;

    if (!isAllowedType) {
      message.error("You can only upload PNG or JPG files!");
      return Upload.LIST_IGNORE; // Prevent the file from being added to the list
    }

    if (!isLessThan5MB) {
      message.error("File must be smaller than 5MB!");
      return Upload.LIST_IGNORE; // Prevent the file from being added to the list
    }

    return true; // Allow the file
  };

  return (
    <>
      {contextHolder}
      {loader && <Loader />}
      <Col xs={12} align="center" className="unitedbgColor p-5 mb-4">
        <p>Create a provider account.</p>
        <h2 className="font-family-Mar">Join For a Good Start</h2>
      </Col>
      <Col xs={12} className="p-lg-5">
        <Form
          form={form}
          layout="vertical"
          name="hospitalForm"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Row className="m-0 px-lg-5">
            <Col md="6" xs="12">
              <Form.Item
                label="Provider Name"
                name="hospitalName"
                rules={[{ required: true }]}
                // normalize={(value) => value?.trim()}
              >
                <Input placeholder="Enter Provider Name" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Provider’s office email"
                name="mailId"
                rules={[
                  { required: true },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input placeholder="Enter Provider’s Office Email" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Contact Number"
                name="phoneNo"
                rules={[{ required: true }, { pattern: /^\d+$/, message: "Contact number must contain only numbers!" },]}
              >
                <Input placeholder="Enter Contact Number" onKeyPress={handleonlyNumber} />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Website"
                name="website"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Website" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Provider Address"
                name="hospitalAddress"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={3} placeholder="Enter Provider Address" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Zip Code"
                name="zipCode"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Zip Code" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Provider Logo"
                name="hospitalLogo"
                // rules={[
                //   { required: true, message: "Please upload Provider Logo!" },
                // ]}
              >
                <Upload
                  beforeUpload={validateFile}
                  accept=".png,.jpeg,.jpg"
                  maxCount={1}
                  fileList={logoFileList} // Correct usage within Upload
                  onChange={({ fileList }) => setLogoFileList(fileList)} // Update state on change
                >
                  <Button icon={<UploadOutlined />}>Upload Logo</Button>
                </Upload>
              </Form.Item>
            </Col>
            {/* <Col md="6" xs="12">
              <Form.Item
                label="Hospital Image"
                name="hospitalImage"
                rules={[
                  { required: true, message: "Please upload Hospital Image!" },
                ]}
              >
                <Upload
                  beforeUpload={validateFile}
                  accept=".png,.jpeg,.jpg"
                  maxCount={1}
                  fileList={imageFileList} // Correct usage within Upload
                  onChange={({ fileList }) => setImageFileList(fileList)} // Update state on change
                >
                  <Button icon={<UploadOutlined />}>Upload Image</Button>
                </Upload>
              </Form.Item>
            </Col> */}
            <Col xs={12}>
              <Form.Item
                name="agree"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject("Should accept agreement"),
                  },
                ]}
              >
                <Checkbox size="large">
                By clicking the checkbox at the point of registration on the site, you acknowledge and agree that you have read, understand, and accept the terms and rules of this agreement. If you do not agree with any of these conditions, do not access or otherwise use the site or any information or materials contained on the site. Your use of the site shall be deemed to be your agreement to each of the terms set forth in this agreement.
                  <a href="#">Terms & Conditions</a>
                </Checkbox>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item>
                <Button
                  className="uniteButton-lg py-4"
                  type="primary"
                  htmlType="submit"
                >
                  Submit For Review
                </Button>
              </Form.Item>
            </Col>
            <div>
              <Icon
                icon="mynaui:danger-triangle-solid"
                width="24"
                height="24"
                style={{ color: "#f6c965" }}
              />
              &emsp;
              <i>
                The review process usually takes about 2 hours. Once it's done,
                our team will call you directly and send you the onboarding link
                by email. This only needs to be done once.
              </i>
            </div>
          </Row>
        </Form>
      </Col>
      <Col className="d-flex flex-wrap justify-content-between p-5">
        <div className="d-flex align-items-center">
          <img src={Logo} alt="Logo" width="50" height="50" />
          <h3 className="ps-3 uniteColor">
            Our Healthcare <br /> Providers Globally
          </h3>
        </div>
        <img src={SunLife} alt="Sun Life" width="100" height="100" />
        <img src={Desjardins} alt="Desjardins" width="100" height="100" />
        <img src={Canadalife} alt="Canada life" width="100" height="100" />
      </Col>
    </>
  );
};

export default Signin;
